/**
 * Controller: TemplatesCreatePricingSalesRules
 */
angular.module('acme.application.templates.create.pricing.salesRules.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.templates',
  'acme.common.directive.feature'
])
  .controller('TemplatesCreatePricingSalesRulesController', [
    '$scope',
    '$timeout',
    'HelpersService',
    'ApiService',
    'TemplatesService',
    function($scope,
             $timeout,
             HelpersService,
             ApiService,
             TemplatesService) {

    $scope.templatesCreatePricingSalesRules = {

      template: {},
      entitlementConfiguration: {},
      hasSalesRules: true,
      prices: [],
      salesRules: [],

      multiSelectTicketLabels: {
        selectAll: "Select all",
        selectNone: "Select none",
        search: "Search by ticket type name...",
        nothingSelected: "Select a ticket type"
      },

      salesRuleTypes: [{
        label: 'Limit',
        name: 'limit'
      }, {
        label: 'Prevent',
        name: 'prevent'
      }],

      init: function () {
        $scope.$on('TemplatesService::Update', this.onTemplatesServiceUpdate);
        $scope.$on('TemplatesCreateController::Save', this.onTemplatesCreateControllerSave);
        $scope.$on('TemplatesCreatePricing::Update', this.onTemplatesCreatePricingUpdate);

        this.getPrices();
      },

      getPrices: function() {
        return ApiService.price.types.list(HelpersService.getPaginator()).then(this.success.getPrices, this.error.getPrices);
      },

      onTemplatesServiceUpdate: function (e, data) {
        var self = $scope.templatesCreatePricingSalesRules;
        self.template = TemplatesService.getModel();
      },

      onTemplatesCreateControllerSave: function(e, data) {
        var self = $scope.templatesCreatePricingSalesRules;

        self.entitlementConfiguration.salesRuleConfig = self.marshall();
        TemplatesService.setSalesRules(self.entitlementConfiguration.salesRuleConfig);
      },

      onTemplatesCreatePricingUpdate: function(e, data) {
        var self = $scope.templatesCreatePricingSalesRules;

        self.template = TemplatesService.getModel();

        self.getPrices().finally(function() {
            if (self.template.id) {
                self.onTemplatesCreateControllerSave();
            }
        });
      },

      loadSalesRules: function() {
        var entitlementConfiguration = this.template.entitlementConfiguration;

        this.entitlementConfiguration = TemplatesService.getEntitlement(true);
        this.salesRules = this.process(this.entitlementConfiguration.salesRuleConfig);
      },

      marshall: function() {
        var self = $scope.templatesCreatePricingSalesRules, salesRules, salesRulesConfig;

        salesRules = self.salesRules.map(function(rule) {
          return {
            pricepointInfo: rule.selectedPricepoints.map(function(pricepoint) {
              var pricepointInfo = self.findPricePoint(pricepoint.id);
              return pricepointInfo ? {
                id: pricepointInfo.pricepoint.id,
                name: pricepointInfo.pricepoint.name
              } : null;
            }).filter(function(princepoint) {
              return princepoint;
            }),
            quantity: rule.quantity,
            filters: rule.preventPricepoints.map(function(pricepoint) {
              var pricepointInfo = self.findPricePoint(pricepoint.id);
              return pricepointInfo ? {
                id: pricepointInfo.pricepoint.id,
                name: pricepointInfo.pricepoint.name
              } : null;
            }).filter(function(princepoint) {
              return princepoint;
            })
          };
        });

        salesRulesConfig = salesRules.map(function(salesRule) {
          var result = {
            quantity: salesRule.quantity
          };

          if(salesRule.pricepointInfo.length > 0 ) {
            result.pricepoints = {
              pricepointInfo: salesRule.pricepointInfo,
              ruleApplies: "acrossAllItems"
            };
          }

          if(salesRule.filters.length > 0 ) {
            result.ruleFilter = {
              filters: salesRule.filters,
              ruleApplies: "acrossAllItems",
              ruleFilterType: "pricepoint"
            };
          }

          return result;
        });

        return salesRulesConfig;
      },

      selectPricepoints: function (list) {
        return this._selectItems(this.prices, list);
      },

      _selectItems: function(allItems, givenItems) {
        var hash = this._buildHash(givenItems),
          _allItems = allItems || [];

        return _allItems.map(function(item) {
          return Object.assign({}, item, {
            ticked: !!hash[item.id]
          });
        });
      },

      _buildHash: function(list) {
        var _list = list || [];

        return _list.reduce(function(hash, item) {
          hash[item.id] = item;

          return hash;
        }, {});
      },

      findPricePoint: function (id) {
        var i, ii,
          r = false;

        for (i = 0, ii = this.prices.length; i < ii; i++) {
          if (id === this.prices[i].id) {
            r = {
              index: i,
              pricepoint: this.prices[i]
            };
            break;
          }
        }

        return r;
      },

      process: function(salesRuleConfig) {
        var self = $scope.templatesCreatePricingSalesRules;

        salesRuleConfig = salesRuleConfig || [];

        angular.forEach(salesRuleConfig, function(salesRule) {
          var hasPricePoints,
              hasRuleFilterPricePoints,
              pricepoints = salesRule.pricepoints,
              ruleFilterPricepoints;

          if (salesRule.hasOwnProperty('ruleFilter')) {
            salesRule.salesRuleType = self.salesRuleTypes[1];

            ruleFilterPricepoints = salesRule.ruleFilter.filters;
            hasRuleFilterPricePoints = (ruleFilterPricepoints instanceof Array) &&
              ruleFilterPricepoints.length;
            salesRule.preventPricepoints = hasRuleFilterPricePoints ? ruleFilterPricepoints : [];
            salesRule.allPreventPricepoints = self.selectPricepoints(hasRuleFilterPricePoints ? salesRule.preventPricepoints : []);

            hasPricePoints = (pricepoints && pricepoints.pricepointInfo instanceof Array) &&
              pricepoints.pricepointInfo.length;
            salesRule.selectedPricepoints = hasPricePoints ? pricepoints.pricepointInfo : [];
            salesRule.allPricepoints = self.selectPricepoints(hasPricePoints ? pricepoints.pricepointInfo : []);
          } else {
            salesRule.salesRuleType = self.salesRuleTypes[0];

            hasPricePoints = (pricepoints && pricepoints.pricepointInfo instanceof Array) &&
              pricepoints.pricepointInfo.length;
            salesRule.selectedPricepoints = hasPricePoints ? pricepoints.pricepointInfo : [];
            salesRule.allPricepoints = self.selectPricepoints(hasPricePoints ? pricepoints.pricepointInfo : []);

            salesRule.preventPricepoints = [];
            salesRule.allPreventPricepoints = self.selectPricepoints();
          }
        });

        return salesRuleConfig;
      },

      stringify: function(object) {
        return JSON.stringify(object, null, '  ');
      },

      validateQuantity: function(rule) {
        rule.quantity = parseInt(rule.quantity, 10) || 0;
      },

      _orderByBusinessRules: function(a, b) {
        var displayNameA = a.displayName || a.name || '',
          displayNameB = b.displayName || b.name || '';

        return displayNameA.toUpperCase() > displayNameB.toUpperCase() ? 1 : -1;
      },

      addSalesRule: function () {
        this.salesRules.push({
          salesRuleType: this.salesRuleTypes[0],
          quantity: '',
          pricepoints: [],
          allPricepoints: this.selectPricepoints(),
          preventPricepoints: [],
          allPreventPricepoints: this.selectPricepoints()
        });
        this.checkSalesRules();
      },

      removeSalesRule: function(index) {
        this.salesRules.splice(index, 1);
        this.checkSalesRules();
      },

      checkSalesRules: function() {
        if (this.salesRules.length <= 0) {
          this.hasSalesRules = false;
        } else {
          this.hasSalesRules = true;
        }
      },

      success: {
        getPrices: function(response) {
          var self = $scope.templatesCreatePricingSalesRules,
          prices = response &&
            response.data &&
            response.data.payload &&
            response.data.payload.list || [];

          self.prices = prices.sort(self._orderByBusinessRules);
          self.loadSalesRules();
        }
      },

      error: {
        getPrices: function(response) {

        }
      }

    };

    $scope.templatesCreatePricingSalesRules.init();
}]);
